module.exports = __webpack_public_path__ + "img/bdl.8868ab95.svg";